import dayjs from 'dayjs';

export class InvoiceValidators {
  /**
   * Validates if the service period is within the trial timeline
   * @param servicesPeriod - The service period in YYYY-MM format
   * @param trialStartDate - The trial start date
   * @param trialEndDate - The trial end date
   * @returns true if the service period is outside the trial timeline
   */
  static validateServicesPeriod(
    servicesPeriod: string,
    trialStartDate: string,
    trialEndDate: string
  ) {
    const invoiceServicePeriod = dayjs(`${servicesPeriod}-01`).startOf('month');
    const trialStartDateDayjs = dayjs(trialStartDate).startOf('month');
    const trialEndDateDayjs = dayjs(trialEndDate).startOf('month');

    return (
      invoiceServicePeriod.isBefore(trialStartDateDayjs) ||
      invoiceServicePeriod.isAfter(trialEndDateDayjs)
    );
  }
}
